import { useErrorReporter } from "~/composables/useErrorReporter";

export default defineNuxtPlugin((nuxtApp) => {
	const { reportError } = useErrorReporter();
	const route = useRoute();

	nuxtApp.hook("apollo:error", ({ graphQLErrors, networkError }) => {
		if (graphQLErrors) {
			for (const err of graphQLErrors) {
				const code = err.extensions?.code;

				if (code === "FORBIDDEN" || code === "UNAUTHENTICATED") {
					if (route.name !== "login") {
						void navigateTo({
							path: "/logout",
							query: {
								redirect: route.fullPath,
							},
						});
					}
				} else {
					reportError(err, `[GraphQL error]: ${err.message}`);
				}
			}
		}

		if (networkError) {
			reportError(networkError, "[Network error]:");
		}
	});
});
